import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { DayOfRaceDate } from '@cds/betting-offer/domain-specific/horse-racing';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';
import { Observable, forkJoin, map } from 'rxjs';

import { DayOfRaceModel, TodayRaceModel } from '../../../horse-racing-shared/model/day-of-race.model';
import { HorseRacingApiService } from '../../../horse-racing-shared/services/horse-racing-api.service';

@Injectable()
export class HorsesTodayResolver {
    constructor(private apiService: HorseRacingApiService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TodayRaceModel> {
        return forkJoin([this.apiService.getDayOfRaceFixtures(DayOfRaceDate.Today), this.apiService.getNextFixtures()]).pipe(
            map(([dayOfRaceFixtures, nextFixtures]: [DayOfRaceModel | undefined, WinGameFixture[]]) => {
                return {
                    fixtures: dayOfRaceFixtures?.fixtures || [],
                    regions: dayOfRaceFixtures?.regions || [],
                    nextFixtures,
                } as TodayRaceModel;
            }),
        );
    }
}
